import Client from '../model/Client';
import m from './module';

const type = 'Client';

class ClientService {
  constructor($q, DataSyncService, API_URL) {
    this.$q = $q;
    this.DataSyncService = DataSyncService;
    this.API_URL = API_URL;
  }

  create(data) {
    const id = data.id || null;
    const promise = this.$q.when(new Client(data));
    return this.DataSyncService.setObjectById(type, id, promise);
  }

  getById(id) {
    return this.DataSyncService.getLocalObjectById(type, id);
  }
}

export default ClientService;

m.service('ClientService', ClientService);
